module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero"
  }, [_c('video', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.1),
      expression: "0.1"
    }],
    ref: "video",
    staticClass: "hero__video",
    attrs: {
      "loop": "loop",
      "muted": "muted",
      "autoplay": "autoplay",
      "playsinline": "playsinline",
      "aria-hidden": "true",
      "aria-label": "Star Smiles Orthopedo Video"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.props.video,
      "poster": _vm.props.poster
    }
  }), _c('p', [_vm._v("Your browser does not support HTML5 video. 😔   ")])]), _c('div', {
    staticClass: "hero__overlay"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('Icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$store.state.nav),
      expression: "!$store.state.nav"
    }],
    staticClass: "hero__overlay-icon",
    attrs: {
      "name": "skyline"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openVideo($event)
      }
    }
  })], 1), _c('div', {
    staticClass: "hero__overlay-btnwrap",
    on: {
      "click": function($event) {
        return _vm.openModal(2)
      }
    }
  }, [_c('div', {
    staticClass: "hero__overlay-btnwrap-btn"
  }, [_vm._v("Schedule a New Patient Appointment ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dff8fae0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero.pug
// module id = 728
// module chunks = 1